export * from './post-abteilung.service';
export * from './post-abteilung.service.module';